// Order status display enum for UI
export enum OrderStatusDisplay {
  ORDER_PLACED = 'order_placed', // Backend: pending
  ORDER_SUBMITTED = 'order_submitted', // Backend: submitted
  SAMPLE_RECEIVED = 'sample_received', // Backend: accessioned
  RESULT_READY = 'result_ready', // Backend: complete
  CANCELLED = 'cancelled', // Backend: cancelled (non-editable; also used for unknown/missing status)
}

export type NavigationSection = 'order-summary' | 'hpo-terms' | 'requisition-form' | 'lab-report'
